import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const RankingWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default RankingWrapper;